import { render, staticRenderFns } from "./DemoUserAlert.vue?vue&type=template&id=028bc90e&scoped=true&"
import script from "./DemoUserAlert.vue?vue&type=script&lang=js&"
export * from "./DemoUserAlert.vue?vue&type=script&lang=js&"
import style0 from "./DemoUserAlert.vue?vue&type=style&index=0&id=028bc90e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028bc90e",
  null
  
)

export default component.exports